import { render, staticRenderFns } from "./test-page.vue?vue&type=template&id=1565ddd6&scoped=true&"
import script from "./test-page.js?vue&type=script&lang=js&"
export * from "./test-page.js?vue&type=script&lang=js&"
import style0 from "./test-page.scss?vue&type=style&index=0&id=1565ddd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1565ddd6",
  null
  
)

export default component.exports